import { gql } from '@apollo/client'

export const MY_CASE_EMAILS_QUERY = gql`
  query MyCaseEmails($page: Int, $limit: Int, $read: Boolean) {
    myCaseEmails(page: $page, limit: $limit, read: $read) {
      collection {
        id
        direction
        status
        fromAddress
        fromName
        toAddresses
        ccAddresses
        subject
        bodyText
        sanitizedBodyHtml
        read
        readAt
        receivedAt
        hasAttachments
        createdAt
        m2Case {
          id
          identifier
          policyholder {
            id
            firstname
            lastname
          }
        }
        processing {
          id
          fileNumber
        }
        attachments {
          url
          filename
          contentType
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`
